// Hooks / Node modules / Styles
import { motion } from "framer-motion";

// Reducers / Actions

// Utils / Functions
import { textVariant } from "src/utils/framer-motion/motion";

// Components

// Sub-Components
import ComponentContainer from "../ComponentContainer";

// Data / Images / Icons
import { TECHNOLOGIES } from "src/data/pages/technologies";

const TechItem = ({ icon, name }) => {
  return (
    <div className="hover:cursor-pointer flex flex-col items-center">
      <div className="w-[60px] h-[60px] object-contain mb-3">
        <img src={icon} alt={name} />
      </div>
    </div>
  );
};

function Tech() {
  return (
    <ComponentContainer
      title="Technologies"
      subtitle="Programming Languages | Frameworks | Tools"
      description=" Here are the technologies, frameworks, and tools I've worked with
          across different projects and domains. Each tool plays a vital role in
          delivering seamless user experiences and highly efficient solutions."
    >
      <div className="mt-16 flex flex-row flex-wrap justify-center gap-8">
        {TECHNOLOGIES.map((tech, index) => (
          <TechItem key={index} icon={tech?.icon} name={tech?.name} />
        ))}
      </div>
    </ComponentContainer>
  );
}

export default Tech;
